export default __webpack_public_path__ + "static/browser_light-bb3b04eb6d8907eca00fcfb2c607a53c.svg";